<template>
  <i-badge
    :label="badgeProperties.label"
    :colour="badgeProperties.colour"
    :icon="badgeProperties.icon"
    :aria-label="badgeProperties.label.toLowerCase()"
    :outline="approvalStatus !== null"
    :disabled="approvalStatus === null"
    class="approval-badge"
    has-leading-icon
  ></i-badge>
</template>

<script>
import * as customerFraudRatingOptions from '@/constants/customerFraudRating';
import { iBadge, iBadgeColours } from '@inscribe/signal';

export default {
  name: 'CustomerApprovalStatus',
  components: {
    iBadge,
  },
  props: {
    approvalStatus: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      options: customerFraudRatingOptions,
      iBadgeColours,
    };
  },
  computed: {
    badgeProperties() {
      const properties = {
        label: '',
        colour: '',
        icon: '',
      };

      switch (this.approvalStatus) {
        case true:
          properties.label = 'Approved';
          properties.colour = iBadgeColours.SUCCESS;
          properties.icon = 'small-solid-check';
          break;
        case false:
          properties.label = 'Rejected';
          properties.colour = iBadgeColours.ERROR;
          properties.icon = 'small-solid-alert-triangle';
          break;
        default:
          properties.label = 'No Status';
          properties.colour = iBadgeColours.DISABLED;
          properties.icon = 'small-solid-question';
          break;
      }

      return properties;
    },
  },
};
</script>

<style lang="scss">
.approval-badge {
  display: inline-flex !important;
}
</style>
